const irregularQtyDrugList = ["a&m-fintab 1 1 mg tablets"];

export default irregularQtyDrugList;
